import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import CartCanceled from './init/CartCanceled';
import Conversion from './init/Conversion';
import ExistingUser from './init/ExistingUser';
import ExistingUserToken from './init/ExistingUserToken';
import ExpiredLink from './init/ExpiredLink';
import ApplyNowIntro from './init/intros/ApplyNowIntro';
import InstoreIntro from './init/intros/InstoreIntro';
import RechargeIntro from './init/intros/RechargeIntro';
import NewBusinessDetails from './init/NewBusinessDetails';
import NewBusinessQualifications from './init/NewBusinessQualifications';
import ProductSelection from './init/ProductSelection';
import UserIsNotBorrower from './init/UserIsNotBorrower';
import UserLockout from './init/UserLockout';
import useSessionEntity from '../../hooks/useSessionEntity';
import ServerRouteGate from '../shared/ServerRouteGate';

export default function Init({ match }) {
  const merchant = useSessionEntity('merchant');

  if (merchant && merchant.isOnHold) return <Redirect to="/error" />;

  return (
    <Switch>
      <Route path={`${match.path}/apply_now`} component={ApplyNowIntro} />
      <Route path={`${match.path}/conversion`} component={Conversion} />
      <Route
        path={`${match.path}/product_selection`}
        render={(props) => (
          <ServerRouteGate workflow="init" action="product_selection">
            <ProductSelection {...props} />
          </ServerRouteGate>
        )}
      />
      <Route path={`${match.path}/recharge_intro`} component={RechargeIntro} />
      <Route path={`${match.path}/instore_intro`} component={InstoreIntro} />
      <Route
        path={`${match.path}/new_business_qualifications`}
        component={NewBusinessQualifications}
      />
      <Route
        path={`${match.path}/new_business_details`}
        component={NewBusinessDetails}
      />
      <Route path={`${match.path}/existing_user`} component={ExistingUser} />
      <Route
        path={`${match.path}/existing_user_token/:type/:contact/:confirm?`}
        component={ExistingUserToken}
      />
      <Route path={`${match.path}/user_lockout`} component={UserLockout} />
      <Route
        path={`${match.path}/user_is_not_borrower`}
        component={UserIsNotBorrower}
      />
      <Route path={`${match.path}/cart_canceled`} component={CartCanceled} />
      <Route path={`${match.path}/expired_link`} component={ExpiredLink} />
    </Switch>
  );
}
